import styled from 'styled-components'
import { ButtonGroup } from '../../molecules/ButtonGroup'
import { ChartSection } from '../../molecules/ChartComponents'

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing.large};
  width: 100%;

  @container (max-width: 650px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }

  @media print {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 16px !important;
    width: 100% !important;
    max-width: 100% !important;
  }
`

export const ChartCard = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  min-width: 0;

  @media print {
    width: 100% !important;
    box-sizing: border-box !important;
    page-break-inside: avoid;
    break-inside: avoid;
    border: 1px solid ${({ theme }) => theme.colors.border.light} !important;
    border-radius: 8px !important;
    padding: 12px !important;
    background: ${({ theme }) => theme.colors.background.primary} !important;
    overflow: visible !important;
    min-width: 0 !important;
  }
`

// Override ChartSection to remove outer border in print for Distribution
export const DistributionChartSection = styled(ChartSection)`
  @media print {
    border: none !important;
    border-radius: 0 !important;
    padding: 0 !important;
    background: transparent !important;
  }
`

export const DistributionViewControls = styled(ButtonGroup)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.medium};

  @media print {
    display: none;
  }
`
